import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-btn',_vm._g(_vm._b({attrs:{"height":"32","width":"32","changes-form":"","icon":""}},'w-btn',_vm.$attrs,false),_vm.$listeners),[_c(VIcon,{attrs:{"size":"18","color":"error"}},[_vm._v("$vuetify.icon.trash")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }